import React from "react";
import {connect} from "react-redux";

import {setAIResults} from "../../aiActions";


const LookAIImagesOverlayItem = (props) => {

  const {aiResult, aiResults, setAIResults} = props;

  const hasResult = aiResult.resultImageUrl;

  const aIResultImageClick = () => {
    if (!hasResult) {
      return null;
    }
    setAIResults(aiResults.map(aiRes => {
      return Object.assign({}, aiRes, {isActive: aiResult.id === aiRes.id});
    }));
  }

  return (
    <li className={"mb-1 rounded-05 look-ai__images-panel-result bg-light bg-center bg-cover relative"
      + (hasResult ? " cursor-pointer" : "")
      + (aiResult.isActive ? " look-ai__images-panel-result--active" : "")}
        key={aiResult.id}
        style={hasResult ? {backgroundImage: `url(${aiResult.resultImageUrl})`} : null}
        onClick={aIResultImageClick}/>
  )
};

const mapStateToProps = (store) => {
  const {aiResults} = store.aiState;

  return {
    aiResults,
  };
};

const mapDispatchToProps = {
  setAIResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookAIImagesOverlayItem)
